<template>
    <div class='page'>
        <div class="desc">手机号码<span class="mobile">【{{mobile}}】</span>已绑定另外一个账号【{{name}}】的用户，需要合并账号吗？</div>
        
        <div class="remark">
          <span class="remark-tips">注意：</span>若选择合并账号，请确认并选择好一个主账号，非选定的账号上的学习课程、作业记录、学习数据等均将丢弃，且无法找回，原账号将被注销！请谨慎操作！
        </div>
        <div class="select_tips">请选择你的主账号：</div>
        <div class="users">
          <div  v-for="(item,index) in list" :key="index"  :class="{'active':item.active}" class="users-item " @click="bindUserClick(item)">
            <div class="item-content">
              <div class="item-header">
                <van-image
                  class="item-photo"
                  radius="5"
                  :src="item.photo"
                />
              </div>
              <div class="item-info">
                <div>
                  <van-tag size="medium" plain color="#B9B9B9">已购课程 {{item.datas.course_num}}</van-tag>
                  <van-tag style="margin-left: 15px;" size="medium" plain color="#B9B9B9">作业记录 {{item.datas.answer_cnt}}</van-tag>
                </div>
                <div >
                  <van-tag size="medium" plain color="#B9B9B9">学习时长 {{item.datas.sum_study_time_cn}}</van-tag>
                </div>
              </div>
            </div>
            <div class="badge" v-if="item.active"><span class="iconfont iconxuanzhong"></span></div>
          </div>
          <template v-if="active_data">
            <div class="span"><span class="iconfont iconxiala1"></span></div>
            <div>
              <div class="users-item ">
                <div class="item-content result-item-content">
                  <div class="item-header">
                    <van-image
                      class="item-photo"
                      radius="5"
                      :src="active_data.photo"
                    />
                  </div>
                  <div class="item-info result-item-info">
                    <div>
                      <span>已购课程 {{active_data.datas.course_num}}</span>
                      <span style="padding-left: 15px">作业记录 {{active_data.datas.answer_cnt}}</span>
                    </div>
                    <div >
                      <span>学习时长 {{active_data.datas.sum_study_time_cn}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="agree"> 
          <van-checkbox icon-size="16px" v-model="checked" >勾选即表示已阅读并同意<span class="notice_tips" @click.stop="bindOpenNotice">《重要提醒》</span></van-checkbox>
          
        </div>
        <div class="operator">
          <van-button color="#F8F8F8" size="large" round style="width: 143px;color:#414141" class="cancle" @click="bindCancel">取消</van-button>
          <van-button type="info" size="large" round style="width: 143px" @click="bindMerge">合并账号</van-button>
        </div>

        <van-popup v-model="show" position="bottom" :style="{ height: '100%' }" >
          <van-nav-bar
            class="my-nav-bar"
            title="重要通知"
            right-text="关闭"
            @click-right="onClickRight"
          />
          <div class="agree_content">
            <h3>为什么要进行账号合并？</h3>
            <p>学员通过不同终端进入平台进行学习、作业等操作，若想多个终端内保持信息同步。即可通过绑定同一手机号，进行账号合并的操作后来达到此效果。</p>

            <h3>账号合并会造成什么影响？</h3>
            <p>账号合并后，会将非主账号的数据舍弃，以主账号（最早产生的账号）的数据为准，其中“学习课程、作业记录、学习时长”都只会使用主账号的数据，其他账号数据全部丢失不可找回。</p>

            <h3>账号不操作合并有什么影响？</h3>
            <p>账号不操作合并对单个终端的学习不造成任何影响，但若想多个终端同步学习则会有影响（例如，学员无法在企业微信学习通过微信H5学习的课程）。</p>
            <p>领取课程就需要绑定手机号码，绑定手机号码输入已绑定手机号码时如不进行账号合并，除非更换未绑定过的手机号码，否则将无法领取课程。</p>

            <h3>账号合并会影响到其他平台的课程吗？</h3>
            <p>不会。所有的账号合并，都是指在同一个平台内进行的。</p>

          </div>
        </van-popup>

        <van-popup class="pop_m_panel" v-model="popup_show_mobile" round  position="bottom" :style1="{ height: '422px' }">
           <div>
              <div class="pop_m_title">
                <div class="pop_m_title_code">请完成手机验证</div>
                <div>
                    <div class="cus_code_button"   >
                      <span v-if="!is_time" @click="bindSendCode()" >发送验证码</span>
                      <van-count-down 
                        ref="countDown"
                        :auto-start="false"
                        @finish="bindCountFinish"
                        v-if="is_time" 
                        :time="time" 
                      >
                        <template #default="timeData">
                          <span class="counttime" >{{timeData.seconds}} s</span>
                        </template>
                      </van-count-down>
                    </div>
                </div>
              </div>
              <div class="pop_m_mobile" hidden>{{mobile}}</div>
              <div>
                  <van-password-input
                      :value="code"
                      :mask="false"
                      :focused="showKeyboard"
                      @focus="showKeyboard = true"
                  />
              </div>
              <div>
                <van-number-keyboard
                      v-model="code"
                      theme="custom"
                      extra-key="."
                      :show="true"
                      close-button-text="完成"
                />
              </div>
           </div>
        </van-popup>


    </div>
</template>
<script>
import {Image as VanImage,Button,Popup,Checkbox, CheckboxGroup,Tag,PasswordInput,CountDown, NumberKeyboard, NavBar, Field,Badge} from 'vant';
import env from '@/utils/env'


export default {
        name: "merge",
        components:{
           [Button.name]:Button,
           [Popup.name]:Popup,
           [Checkbox.name]:Checkbox,
           [CheckboxGroup.name]:CheckboxGroup,
           [Field.name]:Field,
           [NavBar.name]:NavBar,
           [Tag.name]:Tag,
           [VanImage .name]:VanImage ,
           [Field .name]:Field ,
           [NumberKeyboard .name]:NumberKeyboard ,
           [PasswordInput .name]:PasswordInput ,
           [CountDown .name]:CountDown ,
        },
        data(){
            return {
                checked: false,
                show: false,
                popup_show_mobile: false,
                mobile: '',
                name: '',
                list:[],
                active_data: "",
                text: '',
                code: '',
                showKeyboard: false,
                time: 60 * 1000,
                is_time: false,
            }
        },
        computed: {
          
        },
        watch: {
            //监听输入变化
            code(newV, oldV) {
                console.log(newV,oldV)
                if(newV.length == 6){
                  this.util.server.mini_user.merge_users({
                      data:{
                          mobile: this.mobile,
                          code: newV,
                          master_user_id: this.active_data.user_id
                      },
                      callback: (res =>{
                          const {code,data,msg} = res;
                          console.log(res)
                          if(code==-1){
                              // 重置验证码输入框
                              this.code = ''
                              return false
                          }
                          console.log("成功需要跳转")
                          // 清除本地信息 让用户重新登录

                          this.util.logout()
                          //this.util.user_mobile.set(this.mobile);
                          this.$router.replace(this.util.urlPrefix+'/user/mergres?token='+this.util.token);
                      })
                  })
                }
            }
        },
        created() {
            
        },
        
        mounted() {
          this.mobile = this.util.getQueryStr('mobile');
          this.getBindUsers()
        },
        methods:{
          bindUserClick(item){
            this.list.forEach(
              function(value,key){
                value.active = 0
              }
            )
            item.active = !item.active
            this.active_data = item
          },
          bindCancel(){
            // this.show = true
            if(_self.tempRedirect.get(location.href)){
              _self.$router.push(_self.tempRedirect.get(location.href))
            }
          },
          bindOpenNotice(){
            this.show = true
          },
          bindMerge(){
            if(this.active_data==''){
              this.util.showToast({
                  message:'请您先选择一个作为主账号'
              });
              return false
            }
            if(this.checked == false){
              this.util.showToast({
                  message:'请您先阅读并同意'
              });
              return false
            }
            this.popup_show_mobile = true
          },
          onClickRight() {
            this.show = false
          },
          bindCountFinish() {
            this.is_time = false
            this.$refs.countDown.reset();
          },
          bindSendCode(){
            this.is_time = true
            const _self = this
            this.$nextTick(() => {
                _self.$refs.countDown.start();

                this.util.server.user.login_code({
                    data:{
                        mobile:this.mobile
                    },
                    callback:(res =>{
                        const {code,data,msg} = res;
                        if(code == -1){
                            return
                        }

                    })
                })
            })
          },
          getBindUsers(){
                this.util.server.mini_user.get_bind_users({
                    data: {
                        mobile: this.mobile,
                    },
                    callback: (res => {
                       const { code, data, msg } = res;
                        if(res.code == 1){
                            console.log(res)
                            data.master.active= 0 
                            data.others.active= 0 
                            this.name = data.others.user_name
                            this.list.push(data.master)
                            this.list.push(data.others)

                        }
                    })
                })
            },
        }
    }

</script>

<style scoped>

.page {
  padding: 10px 15px;
  background-color: #FFFFFF;
  height: 100%;
}
.desc{
  margin-top: 10px;
  font-size: 18px;
  color: #707070;
  line-height: 25px;
}
.mobile{
  color: RGBA(50, 124, 233, 1);
  font-weight: 600;
}
.users{
  padding-top: 5px;
}
.users-item{
  /* height: 75px; */
  width: 100%;
  background: cadetblue;
  
  border-radius: 9px;
  border: 1px solid #F8F8F8;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px rgba(12, 12, 12, 0.07);
}
.users > .users-item:first-child{
  margin-bottom: 15px;
}
.item-content{
  display: flex;
  padding: 16px;
}
.item-info{
  margin-left: 23px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-photo{
  width: 45px;
  height:45px;
}
.result-item-content{
  background-color: rgba(51, 153, 255, 1);
  box-shadow: 0px 3px 6px rgba(0, 99, 198, 0.27);
}
.result-item-info{
  color: #FFFFFF;
}
.span{
  text-align: center;
  padding:  7px 0;
  color: rgba(50, 124, 233, 1);
}
.active{
  border: 1px solid #327CE9;
  position: relative;
}
.active .iconxuanzhong{
  color: #327CE9;
}
.badge{
  overflow: hidden;
  position: absolute;
  right: 0px;
  top: 0px;
  border-radius: 0px 5px 0px 0px;
}
.remark{
  margin-top: 2px;
  font-size: 12px;
  line-height: 17px;
  color: #FF6600;
}
.remark-tips{
  font-weight: 600;
  color: #FF6600;
}
.agree{
  padding-top: 25px;
  font-size: 14px;
}
.operator{
  display: flex;
  justify-content:space-around;
  padding: 25px 0;
  background-color: #FFFFFF;
}
.cancle >>> .van-button__text{
  color: #414141;
}
.notice_tips{
  color: #327CE9;
}
.agree_content{
  padding: 0px 20px;
}
.my-nav-bar >>> .van-nav-bar__title{
  font-weight: 600;
}
.select_tips{
  padding: 14px 0 10px;
  font-size: 16px;
  line-height: 22px;
  color: #414141;
}
.pop_m_title{
  margin-top: 20px;
  padding: 15px 20px ;
  display: flex;
  justify-content: space-between;
}
.pop_m_title_code{
  font-size: 18px;
  line-height: 32px;
  height: 32px;
  font-weight: 600;
}
  

.pop_m_mobile{
  padding: 10px 20px ;
}
.pop_m_panel{
  height: 435px;
}
.counttime{
  color: #FFF;
}
.cus_code_button{
  width: 88px;
  height: 32px;
  background-color: #1989fa;
  line-height: 32px;
  text-align: center;
  color: #FFF;
  border-radius: 15px;
}
.cus_code_button:active{
  background-color: #55a0eb;
}
.van-count-down{
  height: 32px;
  line-height: 32px;
}
</style>